import { render, staticRenderFns } from "./CurrencySwitcher.vue?vue&type=template&id=6940c62f&scoped=true&"
import script from "./CurrencySwitcher.vue?vue&type=script&lang=ts&"
export * from "./CurrencySwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./CurrencySwitcher.vue?vue&type=style&index=0&id=6940c62f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6940c62f",
  null
  
)

export default component.exports
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtnDropdown,QIcon,QList,QItem,QItemSection});qInstall(component, 'directives', {ClosePopup});
